import React, { useEffect } from "react";
import DatePicker from "react-datepicker";
import ErrorContainer from "./ErrorContainer";

const DateInput = ({
  label,
  formRegister,
  formError,
  formKey,
  dateVal,
  setDateVal,
  isModal = false,
  setFormField,
  notRequired,
  //
  dynamicModalElementInfo,
  setModalInfo,
  dynamicModalInfo,
}) => {
  return (
    <li>
      <label className={notRequired ? "" : "required"}>{label}</label>
      <div class="input-group">
        <DatePicker
          {...formRegister(formKey)}
          selected={dateVal ? new Date(dateVal) : null}
          dateFormat="dd/MM/yyyy"
          onChange={(date) => {
            console.log(date, "1111111");
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();

            setFormField(formKey, `${year}-${month}-${day}`);

            if (!dynamicModalInfo) setDateVal(date);
            else {
              // ! UPDATING DATE VALUE BY UPLIFTING STATE IN DYNAMIC MODAL LOCAL STATE

              const inputElementsArr = dynamicModalInfo?.modalElements?.map(
                (element, idx, arr) => {
                  if (element?.modalKey === dynamicModalElementInfo.modalKey) {
                    return {
                      ...dynamicModalElementInfo,
                      localStateValue: date,
                    };
                  } else return element;
                }
              );

              setModalInfo({
                ...dynamicModalInfo,
                modalElements: inputElementsArr,
              });
            }
          }}
        />
        {<ErrorContainer errors={formError} name={formKey} />}
      </div>
    </li>
  );
};

export default DateInput;
